<template>
  <div>
    <b-modal
      header-class="header-tax"
      id="modal-image"
      no-close-on-esc
      hide-footer
    >
      <template #modal-header>
        <div class="w-100">
          <strong class="title-modal">{{ text }}</strong>
          <b-icon
            icon="x-circle-fill"
            class="float-right pointer"
            @click="closeModal"
          ></b-icon>
        </div>
      </template>
      <div class="px-4 d-flex justify-content-center">
        <div class="fix-image">
          <img class="image" :src="image" />
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    image: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
  },
  methods: {
    closeModal() {
      this.$bvModal.hide("modal-image");
    },
  },
};
</script>

<style scoped>
.fix-image {
  width: 400px;
}
.image {
  width: 100%;
}

/* overide */
</style>
